import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import DocumentsListApp, { DocumentsListAppProps } from "../documents/documents";
import { ResourceAppProps } from "./resource";
import React from "react";
export interface RessPassInGridProps extends ResourceAppProps {
    onRowClicked?: (dataItem: RessPass) => void;
    onRessPassDeleted?: (dataItems: RessPass[]) => void;
}

export default class RessPassInGrid extends React.Component<RessPassInGridProps, {
    gridData: RessPass[]
}>{
    private gridOptions = {};
    editableGridRef: EditableGrid;

    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        };
        this.gridOptions = this.props.context.ressPassInGridOptions;
    }

    componentDidMount() {
        this.bindToSaveSuccessfully();
        this.loadData();
    }

    private bindToSaveSuccessfully = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.loadData();
        });
    }

    private loadData = async () => {
        let url = "Resource/GetGridPassData?id=" + encodeURIComponent(this.props.entity.Ressnr);
        const result = await HTTPService.get<JsonResultClass<RessPass[]>>(url)
        if (result.Code == 0) {
            this.props.entity.RessPassLoaded = true;
            this.setState({ gridData: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createNewEntity = (): RessPass => {
        let entity: RessPass = {
            IsGuid: kendo.guid(),
            IsNew: true
        }
        return entity;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem: RessPass = this.createNewEntity();
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
                    if (isOk) {
                        if (Helper.hasValue(this.props.onRessPassDeleted)) {
                            this.props.onRessPassDeleted(p.selectedItems);
                        }
                        p.actions.deleteSelected(false);
                    }
                });
                break;
        }
    }

    render() {
        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

        let schema = new Schema();
        schema.Id = "IsGuid";
        schema.fields["IsGuid"] = new field("string");
        return <div style={{ display: "flex", flexDirection: "column", height: "50%" }}>
            <EditableGrid data={this.state.gridData}
                id="ressPassInGrid"
                schema={schema}
                gridOptions={this.gridOptions}
                ref={(ref) => this.editableGridRef = ref}
                editable={this.props.entity.RecordRight.CanWrite}
                onDataChanged={() => this.props.context.setEntityDirtyState(true)}
                onRowClicked={(e, dataItem) => {
                    if (Helper.hasValue(this.props.onRowClicked))
                        this.props.onRowClicked(dataItem);
                }}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                {...JSON.parse(JSON.stringify(this.props))} helpEditUrl={this.props.helpUrl}
            />
        </div>
    }
}

export interface RessPass {
    Datum?: Date;
    Ablauf?: Date;
    Noreminder?: boolean;
    Email?: string;
    Premonition?: number;
    Pass?: string;
    Passnr?: string;
    Ressnr?: string;
    Bemerkung?: string;
    Ausstellendebehoerde?: string;
    Arabischeuebersetzung?: string;
    Physischeraufenthaltsort?: string;
    IsGuid?: string;
    IsNew?: boolean;
}